/** @jsx jsx */
import { FC, useContext } from "react";
import { jsx } from "theme-ui";

import { IWithRouteMatchProps } from "@/infrastructure/Route";
import { SessionContext } from "@/infrastructure/Session";
import { useRouter } from "@/router/useRouter";
import { PublicLayout } from "@/views/components/Layout";

import { router } from "../router";
import { ClientPage } from "./ClientPage";
import { ClientPageSearchParams, transformRouteProps } from "./selectors";

interface PublicClientPageProps extends IWithRouteMatchProps {}

export const PublicClientPage: FC<PublicClientPageProps> = props => {
  const { authenticated } = useContext(SessionContext);

  const { slug } = transformRouteProps(props);
  const {
    searchParams: { tab = "details" },
    replace,
  } = useRouter<{}, ClientPageSearchParams>();

  if (authenticated) {
    replace(router.get(`client.${tab}`, { slug }).path);
    return null;
  }

  return (
    <PublicLayout hideFooter={false} hideTopbar={false} borderBottomTopbar={false}>
      <ClientPage isPublic {...props} />
    </PublicLayout>
  );
};
